// extracted by mini-css-extract-plugin
export default {"cta":"uG-z","disabled":"vG-z"};